const SortUtil = {
	getKorChosung: str => {
		// 인벤토리 리스트에서 초성을 추출하기 위한 함수
		// ref: https://zetawiki.com/wiki/UTF-8_%ED%95%9C%EA%B8%80_%EC%B4%88%EC%84%B1_%EC%B6%94%EC%B6%9C_(%EC%9E%90%EB%B0%94%EC%8A%A4%ED%81%AC%EB%A6%BD%ED%8A%B8)
		let cho = [
			'ㄱ',
			'ㄲ',
			'ㄴ',
			'ㄷ',
			'ㄸ',
			'ㄹ',
			'ㅁ',
			'ㅂ',
			'ㅃ',
			'ㅅ',
			'ㅆ',
			'ㅇ',
			'ㅈ',
			'ㅉ',
			'ㅊ',
			'ㅋ',
			'ㅌ',
			'ㅍ',
			'ㅎ',
		]
		let result = ''
		for (let i = 0; i < str.length; i++) {
			let code = str.charCodeAt(i) - 44032
			if (code > -1 && code < 11172) result += cho[Math.floor(code / 588)]
			else result += str.charAt(i)
		}
		return result
	},
	makeFullStoragePath(
		locationPathName,
		storagePathName,
		ellipsisLength = 34
	) {
		// 인벤토리 리스트에서 subtitle를 표시할 때 사용
		const locationPath = locationPathName.replaceAll(',', '/')
		const storagePath = storagePathName.replaceAll(',', '/')
		const fullPath = [locationPath, storagePath].join('/')
		if (fullPath.length >= ellipsisLength) {
			const startIdx = fullPath.length - ellipsisLength
			return `...${fullPath.substr(startIdx)}`
		} else {
			return fullPath
		}
	},
}

export default SortUtil
